import React, { memo, useState } from 'react';
import cn from 'classnames';
import Picker from 'emoji-picker-react';

import { useTranslation } from 'providers/GILT.provider';

import CN from './EmojiPicker.module.scss';

const EmojiPicker = ({ emoji, isNew, onChange, darkTheme, name }) => {
  const [showDropdown, showPicker] = useState(false);
  const { t } = useTranslation();

  const showEmojiPicker = () => showPicker(true);
  const hideEmojiPicker = () => showPicker(false);

  const onClick = (event, emojiObject) => {
    onChange(emojiObject.emoji);
    hideEmojiPicker();
  };

  const PickerDropdown = () => (
    <>
      <div className="close-picker-overlay" role="button" tabIndex={0} onClick={hideEmojiPicker} />
      <div data-bem="PickerDropdown" className="picker-container">
        <Picker onEmojiClick={onClick} disableAutoFocus native />
      </div>
    </>
  );

  const EmojiData = ({ chosenEmoji }) => <>{chosenEmoji}</>;

  return (
    <div data-bem="EmojiPicker" className={cn({ [CN.container]: true, [CN.dark]: darkTheme })}>
      <div data-bem="EmojiPicker__emoji" className={CN.emoji}>
        <span>{t('clientTags.emoji')}</span>
        <span className={CN.emojiImg} role="img" aria-labelledby={name}>
          {emoji && <EmojiData chosenEmoji={emoji} />}
        </span>
      </div>
      <button data-bem="EmojiPicker__change-emoji-button" className={CN.changeEmojiButton} onClick={showEmojiPicker}>
        {isNew ? t('clientTags.chooseEmoji') : t('clientTags.changeEmoji')}
      </button>
      {showDropdown ? <PickerDropdown /> : null}
    </div>
  );
};

export default memo(EmojiPicker);
